import { RouteFactory } from "@app/routePaths";
import uobLogo from "@assets/logo-uob-blue.png";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import { VERTICAL_MASTHEADS } from "@routes/Section/layouts/Verticals/utils/constant";
import { cn } from "@util/helpers";

type AseanBannerProps = {
  /** Optional additional styling to the component */
  className?: string;
};

/**
 * Banner component for the Asean vertical, featuring the masthead and sponsor logo.
 */
const AseanBanner = ({ className }: AseanBannerProps): React.ReactElement => {
  return (
    <div
      className={cn(
        "mx-auto flex w-full flex-wrap items-center justify-center gap-4 border-b border-gray-175 pb-4 lg:justify-between",
        className
      )}
    >
      <SectionMasthead
        link={RouteFactory.aseanBusiness}
        masthead={VERTICAL_MASTHEADS.asean}
        className="w-[12.5rem] lg:w-[15.5rem]"
      />

      <div className="block h-[1px] w-full bg-gray-175 lg:hidden"></div>

      <div className="flex items-center justify-end gap-x-4">
        <span className="font-poppins text-4xs font-normal leading-normal tracking-5% md:text-xs">
          SPONSORED BY
        </span>

        <img src={uobLogo} alt="UOB logo" className="w-[5rem]" width="90" />
      </div>
    </div>
  );
};

export default AseanBanner;
